import { Injectable } from '@angular/core';
import { AppConfigService } from "../common/service/mpvAppConfigService";
import { HttpApiService } from "../common/service/mpvHttpApiService";
import { SigedCommonService } from "../siged-common.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})

export class AreaService {
    private defaultHeaders;
    getListArea: any;

    constructor(
        public httpApiService: HttpApiService,
        public appConfigService: AppConfigService,
        public mpvCommonService: SigedCommonService,
        private http: HttpClient,
        private authService: AuthService,
    ) {
        this.defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    baseUrl = this.mpvCommonService.APPLICATION_API_HOST + "/";


    getSearchAxios(q) {
        return this.httpApiService.get(this.baseUrl, 'area/buscar?q=' + q)
    }

    //-----------------------------BUSCAR CAMPOS AREAS-----------------------------------------------/
    buscarArea(
        params: HttpParams | { descripcionArea: string, size?: string, page?: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}area/buscarArea`, options).toPromise();
    }

    getSedes(): Observable<any> {
        const options = { headers: { ... this.defaultHeaders} }
        return this.http.get(`${this.baseUrl}area/sedes`, options);
    }

    //-------------------------------LISTADO AREA-------------------------------------------------------//
    listarArea(
        params: HttpParams | { nombre: string, size?: string, page?: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}area/listar`, options).toPromise();
    }

    detalleArea(
        params: { idArea: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}area/abrir`, options).toPromise();
    }

    actualizar(
        body: {
            "idArea": string,
            "nombre": string,
            "dependencia": string,
            "idSede": string,
            "idPersonaAa"?: null,
            "idPersonaJa"?: null
        },
        headers?
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}area/actualizar`, body, options).toPromise();
    }

    CrearArea(
        body: {
            "nombre": string,
            "dependencia": number,
            "idSede": string,
        },
        headers?
    ) {
        const options = { headers: { ... this.defaultHeaders, ...headers } }
        return this.http.post(`${this.baseUrl}area/crear`, body, options).toPromise();
    }

    EliminarArea(
        params: { idArea: string },
        headers?
    ) {
        const options = { params, headers: { ... this.defaultHeaders, ...headers } }
        return this.http.get(`${this.baseUrl}area/eliminar`, options).toPromise();
    }
}
